import { render, staticRenderFns } from "./DraftEmails.vue?vue&type=template&id=0f2182f3&scoped=true&"
import script from "./DraftEmails.vue?vue&type=script&lang=js&"
export * from "./DraftEmails.vue?vue&type=script&lang=js&"
import style0 from "./DraftEmails.vue?vue&type=style&index=0&id=0f2182f3&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2182f3",
  null
  
)

export default component.exports